//todo - move
$('[data-toggle-class]').click(function () {
    var toggleClassName = $(this).attr('data-toggle-class');

    if (!toggleClassName.length) {
        return;
    }

    var targetElement = $(this);

    if ($(this).hasAttr('data-toggle-class-target')) {
        targetElement = $($(this).attr('data-toggle-class-target'));
    }

    $(targetElement).toggleClass(toggleClassName);

    if ($(this).hasAttr('data-focus-element-trigger')) {
        var targetFocusElementId = $(this).attr('data-focus-element-trigger');

        var target = $(targetFocusElementId);
        if (target.length && target.is("input")) {
            $(target).focus();
        }
    }
}); 

$('.desktop-header-search').click(function () {
    $(this).addClass("show-search");
});

function offsetMobileDropdown() {
    var headerHeight = $('.sc-component.header').outerHeight() - $('.mobile-header-in-page-nav').outerHeight();
    //console.log($('.sc-component.header').outerHeight());
    //console.log($('.mobile-header-in-page-nav').outerHeight());
    //console.log(headerHeight);

    if (window.scrollY === 0) {
        var alertHeight = $('.sc-component.alert').length ? $('.sc-component.alert').outerHeight() : 0;

        headerHeight += alertHeight;
    }

    $('.mobile-nav-dropdown').css({ 'height': 'calc(100vh - ' + headerHeight + 'px)', 'top': headerHeight });
}

//adds the sticky wrapper class to the header only if the in page navigation is not present
function bindStickyHeader() {
    var header = $('.sc-component.header');

    if (header.length) {
        var inPageNavigationElement = $('.in-page-navigation');

        if (!inPageNavigationElement.length) {
            header.addClass("sticky-wrapper");
        }
    }
}

//offsets component anchors to compensate for current height of the header and in page navigation
window.offsetHeaderInPageNavigationAnchors = function () {

    var inPageNavigationElement = $('.in-page-navigation');
    var headerElement = $('.header');
    var anchorOffset;

    if (inPageNavigationElement.length) {
        anchorOffset = $(inPageNavigationElement).outerHeight() + 1;
    }
    else if (headerElement.length) {
        anchorOffset = $(headerElement).outerHeight() + 1;
    }

    if (anchorOffset) {
        //unique anchor links
        $('.anchor').css("top", anchorOffset);

        //component based anchor links
        $('.sc-component').css("scroll-margin-top", anchorOffset);

        $('[data-scroll-margin-top]').css("scroll-margin-top", anchorOffset);

        $('[data-sticky]').attr("data-margin-top", anchorOffset);

        //scrollspy offset
        //$('[data-spy]').attr('data-offset', anchorOffset);
    }

    //var $headerInPageNavElement = $(".header-in-page-nav");
    //var $mobileInPageNavElement = $(".mobile-header-in-page-nav");

    $('body').scrollspy('dispose');

    //initialize body scrollspy with post-load calculated offset
    if ($(window).width() >= 992) {
        $('body').scrollspy({ target: '.header-in-page-nav .header-in-page-nav-scrollspy', offset: anchorOffset ?? 0 });
    }
    else {
        $('body').scrollspy({ target: '.mobile-header-in-page-nav .header-in-page-nav-scrollspy', offset: anchorOffset ?? 0 });
    }
}

window.initHeaderInPageNavScrolling = function () {
    var $headerInPageNavList = $(".header-in-page-nav-list");
    if ($headerInPageNavList.length > 0) {
        if ($(window).width() >= 992) {
            var headerInPageNavList = $headerInPageNavList[0];
        }
        else {
            var headerInPageNavList = $headerInPageNavList[1];
        }
        var $headerInPageNavPrevContainer = $(".header-in-page-nav-prev-container");
        var $headerInPageNavNextContainer = $(".header-in-page-nav-next-container");
        if (headerInPageNavList.offsetWidth < headerInPageNavList.scrollWidth) {
            $headerInPageNavList.addClass("controls-visible");
            $headerInPageNavPrevContainer.show();
            $headerInPageNavNextContainer.show();

        } else {
            $headerInPageNavList.removeClass("controls-visible");
            $headerInPageNavPrevContainer.hide();
            $headerInPageNavNextContainer.hide();
        }
    }
}

window.headerInPageNavScrollLeft = function () {
    var $headerInPageNavList = $(".header-in-page-nav-list");
    $headerInPageNavList.animate({
        scrollLeft: "-=250"
    }, 250);
    
};

window.headerInPageNavScrollRight = function () {
    var $headerInPageNavList = $(".header-in-page-nav-list");
    $headerInPageNavList.animate({
        scrollLeft: "+=250"
    }, 250);
};

$(document).ready(function () {

    // Apply active class to show/hide main menu dropdowns when the corresponding main menu link is hovered/unhovered over.
    $(".dropdown-menu-link.has-dropdown").hover(
        function () {
            var $dropdownMenuLink = $(this);
            var $allDropdownMenuLinksWithDropdowns = $(".dropdown-menu-link.has-dropdown");
            var index = $allDropdownMenuLinksWithDropdowns.index(this);
            var $dropdownContainer = $(".main-nav-dropdowns");
            var $dropdownMenu = $($dropdownContainer.children()[index]);
            $dropdownMenu.addClass("active");
        },
        function () {
            var $dropdownMenuLink = $(this);
            var $allDropdownMenuLinksWithDropdowns = $(".dropdown-menu-link.has-dropdown");
            var index = $allDropdownMenuLinksWithDropdowns.index(this);
            var $dropdownContainer = $(".main-nav-dropdowns");
            var $dropdownMenu = $($dropdownContainer.children()[index]);
            $dropdownMenu.removeClass("active");
        }
    );

    $(window).on('resize', throttle(function () {
        offsetHeaderInPageNavigationAnchors();
    }, 400));

    initHeaderInPageNavScrolling();

    $(window).on('resize', throttle(function () {
        initHeaderInPageNavScrolling();
    }, 100));

    if (!$('body').hasClass('experience-editor')) {
        bindStickyHeader();
        offsetMobileDropdown();

        $(window).on('resize', throttle(function () {
            offsetMobileDropdown();
        }, 400));

        $(document).on('scroll', throttle(function () {
            offsetMobileDropdown();
        }, 400));
    }

});

//image load dependent functions
$(window).on('load', function () {
    offsetHeaderInPageNavigationAnchors();
});